import React from 'react';

import { formatMoney } from '@meterup/atto';
import { Quote } from '@meterup/connect-api';
import cx from 'classnames';

import styles from './FormattedMonthlyAmount.module.css';

export function FormattedQuoteMonthlyAmount({ quote }: { quote: Quote }) {
  const formattedAmount = formatMoney({
    amount: Math.ceil(quote.monthlyFeeCents / 100),
    hideCentsIfZero: true,
  });
  const [roundedAmount, cents] = formattedAmount.toString().split('.');

  return (
    <div className="text-gray-800 inline-block flex items-center">
      <span className="inline-block ">{roundedAmount}</span>
      <sup
        className={cx('font-normal text-gray-700 ml-nudge-2px inline-block self-top', styles.sup)}
      >
        {cents}
      </sup>

      <span className={cx('font-normal text-gray-600 ml-1 inline-block', styles.monthlyAddon)}>
        /mo
      </span>
    </div>
  );
}

export const FormattedQuoteMonthlyAmountSimple: React.FunctionComponent<{ quote: Quote }> = ({
  quote,
}) =>
  formatMoney({
    amount: Math.ceil(quote.monthlyFeeCents / 100),
    hideCentsIfZero: true,
  });
